var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bread-crumb-wrapper"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }